/***
 * Configuration for Demands Routes
 *
 * Demand Routes
 ***/

/* ----- Views ----- */

// Demand
import Demands from "@/pages/Demands/Demands";
import DemandAdd from "@/pages/Demands/DemandAdd";
import DemandDetails from "@/pages/Demands/DemandDetails";
import DemandEdit from "@/pages/Demands/DemandEdit";

/* ----- ----- ----- ----- ----- ----- ----- */

// Utils
import { generateParentsList } from "@/router/utils";

// Parents List
const parentsList = {
    demandsIndex: { label: 'Liste des demandes', name: 'Demands' },
    demandDetails: {
        label: 'Détails d\'une demande',
        shortLabel: 'Demande #',
        name: 'Demand Details',
        params: { name: 'demandId', model: 'Demand\\Demand', column: 'id' },
    },
}

const demandRoutes = [
    {
        path: 'demands',
        name: 'Demands',
        component: Demands,
        meta: {
            route: {
                label: 'Liste des demandes'
            }
        },
    },
    {
        path: 'demands/create',
        name: 'Demand Add',
        component: DemandAdd,
        meta: {
            route: {
                label: 'Ajout d\'une demande'
            },
            parents: generateParentsList(parentsList, ['demandsIndex']),
        },
    },
    {
        path: 'demands/:demandId',
        name: 'Demand Details',
        component: DemandDetails,
        meta: {
            route: {
                label: 'Détails d\'une demande',
                shortLabel: 'Demande #',
                params: { name: 'demandId', model: 'Demand\\Demand', column: 'id' },
            },
            parents: generateParentsList(parentsList, ['demandsIndex']),
        },
    },
    {
        path: 'demands/:demandId/edit',
        name: 'Demand Edit',
        component: DemandEdit,
        meta: {
            route: {
                label: 'Modification d\'une demande'
            },
            parents: generateParentsList(parentsList, ['demandsIndex', 'demandDetails']),
        },
    }
]

const routes = [...demandRoutes]
export default routes